import React, { useState, useEffect } from 'react';
import { useQuery } from '@apollo/client';
import { Box, Button, CircularProgress, Container, Divider } from '@mui/material';

import { LOAD_QR_CODES_QUERY } from 'globals/graphql';
import QRCodeList from './components/QRCodeList';
import { useSnackbar, useAnalytics, useScreenSize } from "globals/hooks";
import QRCodeCreationModal from './components/QRCodeCreationModal';
import { QRCodeAppProps } from './types';
import { AppInfoHeader, AppInfoContent } from '../AppInfoSections';

export function QRCodeApp(props: QRCodeAppProps) {
  const { app, onAppClose } = props;
  const [isCreationModalOpen, setIsCreationModalOpen] = useState(false);

  // hooks
  const snackbar = useSnackbar();
  const { track } = useAnalytics();
  const { isMobileView } = useScreenSize();

  useEffect(() => {
    track('qrCodeApp_visited');
  }, [track]);

  const { data, loading, refetch } = useQuery(LOAD_QR_CODES_QUERY, {
    fetchPolicy: 'network-only',
  });

  // handlers
  const handleBackToMoovsMarket = () => {
    onAppClose();
  };

  const handleOpenCreationModal = () => {
    setIsCreationModalOpen(true);
  };

  const handleCloseCreationModal = () => {
    setIsCreationModalOpen(false);
  };

  const handleQRCodeCreated = () => {
    refetch();
    handleCloseCreationModal();
    snackbar.success('Your QR Code was generated');
  };

  return (
    <Container maxWidth="md">
      {/* Moovs Market App Headers */}
      <AppInfoHeader
        onBack={handleBackToMoovsMarket}
        isActive={app.active}
      />

      <Divider />

      <AppInfoContent
        app={app}
        isMobileView={isMobileView}
      />

      {/* QR Code App */}
      <Box sx={{ display: 'flex', justifyContent: 'flex-start', mb: 2 }}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleOpenCreationModal}
        >
          Create a New QR Code
        </Button>
      </Box>

      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
          <CircularProgress />
        </Box>
      ) : (
        <QRCodeList
          qrCodes={data?.loadQrCodes || []}
          onRefresh={refetch}
        />
      )}

      <QRCodeCreationModal
        open={isCreationModalOpen}
        onClose={handleCloseCreationModal}
        onSuccess={handleQRCodeCreated}
      />
    </Container>
  );
}; 